import { usePostHog } from "posthog-js/react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import content_my from "./content_my.json";
import {
  ButtonStyled,
  GridStyledTagline,
  GridTagline,
  TaglineSubtitle,
  TaglineTitle,
} from "./styles";

export default function FreeTextBanner(props) {
  const { onScrollToPackage } = props;
  const [tagline, setTagline] = useState([]);

  const dispatch = useDispatch();

  async function fetchData() {
    // const responseApi = await dispatch(fetchEmployerTagline());

    const response = content_my;

    const { tagline } = response || {};

    setTagline(tagline);
  }

  const posthog = usePostHog();
  const buttonCTA = "Claim My Free Posts";
  const buttonColour = "yellow";

  function triggerInfoDialog() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "post_for_free_join_platform",
    });
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <GridStyledTagline>
        {tagline?.slice(0, 1).map((tagline) => {
          return (
            <>
              <GridTagline>
                <TaglineTitle
                  dangerouslySetInnerHTML={{ __html: tagline?.mainTitle }}
                />
                <TaglineSubtitle
                  dangerouslySetInnerHTML={{ __html: tagline?.subTitle }}
                />
              </GridTagline>
            </>
          );
        })}

        <ButtonStyled onClick={triggerInfoDialog}>{buttonCTA}</ButtonStyled>
      </GridStyledTagline>
    </>
  );
}
